<template>
  <div>
    <header class="flex space-x-4">
      <svg
        class="w-6 h-6"
        :class="[{ 'text-green-700': isComplete }, { 'text-red-700': !isComplete }]"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- eslint-disable max-len -->
        <path
          v-if="isComplete"
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd"
        ></path>
        <path
          v-else
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
          clip-rule="evenodd"
        ></path>
        <!-- eslint-enable max-len -->
      </svg>

      <h3>Member</h3>
    </header>
    <section class="mt-1 p-4 rounded bg-gray-100">
      <div class="flex justify-between">
        <p class="flex-none">Pension Start Date</p>
        <p class="font-bold">{{ startDate | moment('DD/MM/YYYY') }}</p>
      </div>
      <hr class="my-1" />
      <div class="flex justify-between">
        <h3 class="font-bold">{{ member }}</h3>
        <p>{{ dateOfBirth | moment('DD/MM/YYYY') }}</p>
      </div>
      <div class="flex justify-between text-sm">
        <p class="flex-none text-gray-600">Pensioner's Age</p>
        <p>{{ pensionerAge }} yrs</p>
      </div>
      <div class="flex justify-between text-sm">
        <p class="flex-none text-gray-600">Preservation Age</p>
        <p>{{ preservationAge }} yrs</p>
      </div>
      <hr class="my-1" />
      <div class="flex justify-between items-baseline space-x-2 text-sm">
        <p class="flex-none text-gray-600">Release Condition</p>
        <p class="leading-tight">{{ eligibilityReason }}</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'pension-tracker-member',
  computed: {
    getPensionKit() {
      return this.$store.getters['toolkit/getItemData'];
    },
    isComplete() {
      return this.startDate && this.member && this.pensionerAge && this.preservationAge;
    },
    startDate() {
      return this.getPensionKit.requirements.startDate !== ''
        ? this.getPensionKit.requirements.startDate
        : undefined;
    },
    member() {
      return this.getPensionKit.requirements.member.name !== ''
        ? this.getPensionKit.requirements.member.name
        : undefined;
    },
    dateOfBirth() {
      return this.getPensionKit.requirements.member.dateOfBirth !== ''
        ? this.getPensionKit.requirements.member.dateOfBirth
        : undefined;
    },
    pensionerAge() {
      return this.getPensionKit.requirements.member.age !== 0
        ? this.getPensionKit.requirements.member.age
        : undefined;
    },
    preservationAge() {
      return this.getPensionKit.requirements.member.preservationAge !== 0
        ? this.getPensionKit.requirements.member.preservationAge
        : undefined;
    },
    eligibilityReason() {
      return this.getPensionKit.requirements.eligibility.reasons !== ''
        ? this.getPensionKit.requirements.eligibility.reasons
        : 'N/A';
    },
  },
};
</script>

<style></style>
